import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "bs-table-column-manager",
  ref: "container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1)
const _hoisted_3 = { class: "tooltip__container" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_bs_checkbox = _resolveComponent("bs-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_bs_button, {
      ref: "reference",
      onClick: _ctx.open
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" Колонки ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_Transition, { name: "m-tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "bs-m-tooltip bs-table-column-manager__tooltip",
              ref: "tooltip",
              style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` })
            }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "container__item",
                    key: column.key,
                    onClick: ($event: any) => (_ctx.toggleColumn(column))
                  }, [
                    _createTextVNode(_toDisplayString(column.name) + " ", 1),
                    _createVNode(_component_bs_checkbox, {
                      size: "small",
                      "model-value": _ctx.isColumnDisplayed(column)
                    }, null, 8, ["model-value"])
                  ], 8, _hoisted_4))
                }), 128))
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}